.Question {
	background: var(--white);
	border-radius: 11px;
	padding: 25px 20px 25px;
	margin-bottom: 40px;
	box-shadow: var(--wide-shadow);
}
